import { endpoints, host } from '@config/endpoints';
import request from './request';

export const getSectorScore = async (Isiccode: string) => {
    const { path, method } = endpoints.dashboard.getSectorScore;

  let err = null;
  let res: any = null;

  try {
    ({ data: res } = await request(
        `${host}${path}/${Isiccode}`,
      method,
      {},
      {},
    ));
  } catch (error) {
    // @ts-ignore
    err = error.message;
  }

  return [err, res];
};
